import { render } from "./InstructionDesktop.vue?vue&type=template&id=4048335f"
import script from "./InstructionDesktop.vue?vue&type=script&lang=js"
export * from "./InstructionDesktop.vue?vue&type=script&lang=js"

import "./InstructionDesktop.vue?vue&type=style&index=0&id=4048335f&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__